import React from "react";

// import { useSelector } from "react-redux";
// import Loginpage from "./Loginpage";

// import PassworCheck from "./checkTempPassword";
import MainComponent from "./MainComponent";
function Mainpage() {
  // const isLogin = useSelector((state) => state.Login.isLogin);

  return <div>
    <MainComponent/>
    {/* {isLogin ? <PassworCheck /> : <Loginpage />} */}
    </div>;
}
export default Mainpage;
